import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { SalesAgent } from '../../../../features/sales/models/sales-agent.model';
import { tap } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { LoaderComponent } from '../../../general/components/loader/loader.component';
import { PhonePipe } from '../../../pipes/phone-number.pipe';

@Component({
  selector: 'app-sales-agent-manger',
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatSortModule,
    MatCardModule,
    LoaderComponent,
    PhonePipe
  ],
  templateUrl: './sales-agent-manger.html',
  styleUrl: './sales-agent-manger.scss',
})
export class SalesAgentMangerComponent implements OnInit {
  private service = inject(AdminService);
  private cdr = inject(ChangeDetectorRef);

  isLoading = false;
  salesAgents: SalesAgent[] = [];
  displayedColumns: string[] = ['displayName', 'street'];
  dataSource = new MatTableDataSource<SalesAgent>();
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.dataSource.paginator = mp;
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.dataSource.sort = ms;
  }

  ngOnInit(): void {
    this.loadSalesAgents();
  }

  loadSalesAgents = () => {
      this.isLoading = true;
  
      this.service.getSalesAgents().pipe(
        tap((agents: SalesAgent[]) => {
          console.log('agents', agents);
          this.salesAgents = agents;
        })).subscribe({
          next: (agents) => {
              this.setupDataSource(agents);
              this.isLoading = false; 
              this.cdr.detectChanges();
          },
          error: (err) => {
              console.error('Error loading sales agents:', err);
              this.isLoading = false; 
              this.cdr.detectChanges();
          }
      });
    }
  
    private setupDataSource(agents: SalesAgent[]): void {
      this.salesAgents = agents; 
      this.dataSource.data = agents.filter(a => a.firstName !== 'place' && a.lastName !== 'holder');

      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'name': return (item.firstName + item.lastName).toLowerCase();
          case 'referringAgentId': return this.getAgentName(item.referringAgentId);
          default: return (item as any)[property];
        }
      };

      if (this.matPaginator) {
          this.dataSource.paginator = this.matPaginator;
      }
      if (this.matSort) {
          this.dataSource.sort = this.matSort;
      }
    }

    getAgentName(id: number): string {
      const agent = this.salesAgents.find(agent => agent.agentId === id);
      return agent ? `${agent.firstName} ${agent.lastName}` : '';
    }
}
